import type { PagedResultDto } from "@services/dto/pagedResultDto"
import dashboardService from "@services/report/dashboardService"
import { action, makeAutoObservable, observable } from "mobx"

class DashboardStore {
  // Tiến độ phê duyệt hợp đồng
  @observable dataApprovedContract!: any
  @observable loadingApprovedContract!: boolean

  // Tiến độ thanh toán
  @observable dataSummaryDashboardPayment!: any
  @observable loadingSummaryDashboardPayment!: boolean

  // Tổng tiền thu
  @observable dataContractToReceipt!: any
  @observable loadingContractToReceipt!: boolean

  // Tổng tiền thu theo hợp đồng
  @observable dataContractDebtLedger!: PagedResultDto<any[]>
  @observable loadingContractDebtLedger!: boolean

  // Khách hàng tổng quan
  @observable dataSummaryCustomer!: any
  @observable loadingSummaryCustomer!: boolean

  // Khách hàng tăng trưởng theo ngày
  @observable dataSummaryByDate!: any
  @observable loadingSummaryByDate!: boolean

  // Khách hàng mua theo nhóm loại sản phẩm
  @observable dataSummaryCustomerGroupByProductType!: any
  @observable loadingSummaryCustomerGroupByProductType!: boolean

  // Tiền thu theo tháng
  @observable dataSummaryMonthlyTotalPaymentWithYear!: any
  @observable loadingSummaryMonthlyTotalPaymentWithYear!: boolean

  // Doanh số theo tháng
  @observable dataSummaryMonthlyTotalRevenueWithYear!: any
  @observable loadingSummaryMonthlyTotalRevenueWithYear!: boolean

  // Khách hàng trong sàn
  @observable dataAgencyMasterCustomerCount!: any
  @observable loadingAgencyMasterCustomerCount!: boolean

  // Thông số BK và hợp đồng theo sàn
  @observable dataSummaryAgencyMasterPerformance!: any
  @observable loadingSummaryAgencyMasterPerformance!: boolean

  // Tổng quan trạng thái sản phẩm
  @observable dataSummaryUnitStatus!: any
  @observable loadingSummaryUnitStatus!: boolean

  // Thông số BK và hợp đồng dự án
  @observable dataSummaryProjectPerformance!: any
  @observable loadingSummaryProjectPerformance!: boolean

  // Tổng quan trạng thái sản phẩm theo dự án
  @observable dataSummaryUnitStatusWithProject!: any
  @observable loadingSummaryUnitStatusWithProject!: boolean

  constructor() {
    makeAutoObservable(this)
    this.dataApprovedContract = null
    this.loadingApprovedContract = false
    this.dataSummaryDashboardPayment = null
    this.loadingSummaryDashboardPayment = false
    this.dataContractToReceipt = null
    this.loadingContractToReceipt = false
    this.dataContractDebtLedger = { items: [], totalCount: 0 }
    this.loadingContractDebtLedger = false
    this.dataSummaryCustomer = null
    this.loadingSummaryCustomer = false
    this.dataSummaryByDate = null
    this.loadingSummaryByDate = false
    this.dataSummaryCustomerGroupByProductType = null
    this.loadingSummaryCustomerGroupByProductType = false
    this.dataSummaryMonthlyTotalPaymentWithYear = null
    this.loadingSummaryMonthlyTotalPaymentWithYear = false
    this.dataSummaryMonthlyTotalRevenueWithYear = null
    this.loadingSummaryMonthlyTotalRevenueWithYear = false
    this.dataAgencyMasterCustomerCount = null
    this.loadingAgencyMasterCustomerCount = false
    this.dataSummaryAgencyMasterPerformance = null
    this.loadingSummaryAgencyMasterPerformance = false
    this.dataSummaryUnitStatus = null
    this.loadingSummaryUnitStatus = false
    this.dataSummaryProjectPerformance = null
    this.loadingSummaryProjectPerformance = false
    this.dataSummaryUnitStatusWithProject = null
    this.loadingSummaryUnitStatusWithProject = false
  }

  @action
  getApprovedContract = async (params: any) => {
    this.loadingApprovedContract = true
    this.dataApprovedContract = await dashboardService
      .getApprovedContract(params)
      .finally(() => (this.loadingApprovedContract = false))
    return this.dataApprovedContract
  }

  @action
  getSummaryDashboardPayment = async (params: any) => {
    this.loadingSummaryDashboardPayment = true
    this.dataSummaryDashboardPayment = await dashboardService
      .getSummaryDashboardPayment(params)
      .finally(() => (this.loadingSummaryDashboardPayment = false))
    return this.dataSummaryDashboardPayment
  }

  @action
  getContractToReceipt = async (params: any) => {
    this.loadingContractToReceipt = true
    this.dataContractToReceipt = await dashboardService
      .getContractToReceipt(params)
      .finally(() => (this.loadingContractToReceipt = false))
    return this.dataContractToReceipt
  }

  @action
  getContractDebtLedger = async (params: any) => {
    this.loadingContractDebtLedger = true
    this.dataContractDebtLedger = await dashboardService
      .GetContractDebtLedger(params)
      .finally(() => (this.loadingContractDebtLedger = false))
    return this.dataContractDebtLedger
  }

  @action
  getSummaryCustomer = async (params: any) => {
    this.loadingSummaryCustomer = true
    this.dataSummaryCustomer = await dashboardService
      .GetSummaryCustomer(params)
      .finally(() => (this.loadingSummaryCustomer = false))
    return this.dataSummaryCustomer
  }

  @action
  getSummaryByDate = async (params: any) => {
    this.loadingSummaryByDate = true
    this.dataSummaryByDate = await dashboardService
      .GetSummaryByDate(params)
      .finally(() => (this.loadingSummaryByDate = false))
    return this.dataSummaryByDate
  }

  @action
  getSummaryCustomerGroupByProductType = async (params: any) => {
    this.loadingSummaryCustomerGroupByProductType = true
    this.dataSummaryCustomerGroupByProductType = await dashboardService
      .getSummaryCustomerGroupByProductType(params)
      .finally(() => (this.loadingSummaryCustomerGroupByProductType = false))
    return this.dataSummaryCustomerGroupByProductType
  }

  @action
  getSummaryMonthlyTotalPaymentWithYear = async (params: any) => {
    this.loadingSummaryMonthlyTotalPaymentWithYear = true
    this.dataSummaryMonthlyTotalPaymentWithYear = await dashboardService
      .getSummaryMonthlyTotalPaymentWithYear(params)
      .finally(() => (this.loadingSummaryMonthlyTotalPaymentWithYear = false))
    return this.dataSummaryMonthlyTotalPaymentWithYear
  }

  @action
  getSummaryMonthlyTotalRevenueWithYear = async (params: any) => {
    this.loadingSummaryMonthlyTotalRevenueWithYear = true
    this.dataSummaryMonthlyTotalRevenueWithYear = await dashboardService
      .getSummaryMonthlyTotalRevenueWithYear(params)
      .finally(() => (this.loadingSummaryMonthlyTotalRevenueWithYear = false))
    return this.dataSummaryMonthlyTotalRevenueWithYear
  }

  @action
  getAgencyMasterCustomerCount = async (params: any) => {
    this.loadingAgencyMasterCustomerCount = true
    this.dataAgencyMasterCustomerCount = await dashboardService
      .getAgencyMasterCustomerCount(params)
      .finally(() => (this.loadingAgencyMasterCustomerCount = false))
    return this.dataAgencyMasterCustomerCount
  }

  @action
  getSummaryAgencyMasterPerformance = async (params: any) => {
    this.loadingSummaryAgencyMasterPerformance = true
    this.dataSummaryAgencyMasterPerformance = await dashboardService
      .getSummaryAgencyMasterPerformance(params)
      .finally(() => (this.loadingSummaryAgencyMasterPerformance = false))
    return this.dataSummaryAgencyMasterPerformance
  }

  @action
  getSummaryUnitStatus = async (params: any) => {
    this.loadingSummaryUnitStatus = true
    this.dataSummaryUnitStatus = await dashboardService
      .getSummaryUnitStatus(params)
      .finally(() => (this.loadingSummaryUnitStatus = false))
    return this.dataSummaryUnitStatus
  }

  @action
  getSummaryProjectPerformance = async (params: any) => {
    this.loadingSummaryProjectPerformance = true
    this.dataSummaryProjectPerformance = await dashboardService
      .getSummaryProjectPerformance(params)
      .finally(() => (this.loadingSummaryProjectPerformance = false))
    return this.dataSummaryProjectPerformance
  }

  @action
  getSummaryUnitStatusWithProject = async (params: any) => {
    this.loadingSummaryUnitStatusWithProject = true
    this.dataSummaryUnitStatusWithProject = await dashboardService
      .getSummaryUnitStatusWithProject(params)
      .finally(() => (this.loadingSummaryUnitStatusWithProject = false))
    return this.dataSummaryUnitStatusWithProject
  }
}

export default DashboardStore
